import React from 'react';
import EventButton from 'components/EventButton';

export default (props) => (
    <EventButton {...props} color="primary" variant="outlined">
        {props.children}
    </EventButton>
);